// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"TimexChart_chartContainer__36UTA","timexChart":"TimexChart_timexChart__3vE2a"};